// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {

    background-color: #f1f7ff;

}
.imagesContainer {
    position: relative;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
}

.imgFade {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    opacity: 0; /* ברירת מחדל */
    transition: opacity 1s ease-in-out; /* מעבר רך */
    z-index: 1; /* זיהוי סדר התמונות */
}

.fadeInClass {
    opacity: 1; /* תמונה נכנסת */
    z-index: 2; /* מעל התמונה הקודמת */
}

.fadeOutClass {
    opacity: 0; /* תמונה יוצאת */
    z-index: 1; /* מתחת לתמונה החדשה */
}


  

.monitorPageContainerFull {
    display: flex;
    background-image: linear-gradient(150deg, #061ca7 0%, #67dce2 100%);
    flex-direction: column;
    height: 100vh;
    align-items: center;
    padding-top: 20px;
    justify-content: flex-end;
}
.queuesRoomsMonitorContainerBig{
    display: flex;
}

.monitorPageContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

}




.openMonitor {
    padding: 10px;
    border-radius: 10px;
    width: 300px;
    height: 120px;
    font-size: 30pt;
    font-weight: 700;
    background-color: #f4f4f4;
    /* צבע כפתור בולט */
    color: rgb(78, 98, 246);
    cursor: pointer;
    border: none;
    transition: background-color 0.3s ease;
}

.openMonitor:hover {
    background-color: #e3eaff;
    /* שינוי צבע בהובר */
}

.queuesRoomsMonitorContainer {
    display: flex;
    flex-wrap: wrap;
    /* מאפשר סידור לשורות */
    gap: 10px;
    /* רווחים בין הרכיבים */
    justify-content: center;
    /* ממרכז את הרכיבים אופקית */
    align-items: center;
    /* ממרכז את הרכיבים אנכית */
    height: 100%;
    /* תופס את גובה המסך */

}

.roomMonitorContainer {

    /* width: 350px;
    height: 300px;
    background-color: white; */


}

.dateDisplay {
    color: white;
    font-weight: 700;
    font-size: 18pt;
}

@media (max-width: 768px) {
    .roomMonitorContainer {
        width: 250px;
        height: 190px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/MonitorPage/MonitorPage.css"],"names":[],"mappings":"AAAA;;;IAGI,yBAAyB;;AAE7B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,UAAU,EAAE,eAAe;IAC3B,kCAAkC,EAAE,YAAY;IAChD,UAAU,EAAE,sBAAsB;AACtC;;AAEA;IACI,UAAU,EAAE,gBAAgB;IAC5B,UAAU,EAAE,sBAAsB;AACtC;;AAEA;IACI,UAAU,EAAE,gBAAgB;IAC5B,UAAU,EAAE,sBAAsB;AACtC;;;;;AAKA;IACI,aAAa;IACb,mEAAmE;IACnE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;;;;;AAKA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;;AAE1B;;AAEA;;IAEI;;8BAE0B;;;AAG9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":["html,\r\nbody {\r\n\r\n    background-color: #f1f7ff;\r\n\r\n}\r\n.imagesContainer {\r\n    position: relative;\r\n    overflow: hidden;\r\n    width: 100vw;\r\n    height: 100vh;\r\n}\r\n\r\n.imgFade {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    object-fit: cover;\r\n    opacity: 0; /* ברירת מחדל */\r\n    transition: opacity 1s ease-in-out; /* מעבר רך */\r\n    z-index: 1; /* זיהוי סדר התמונות */\r\n}\r\n\r\n.fadeInClass {\r\n    opacity: 1; /* תמונה נכנסת */\r\n    z-index: 2; /* מעל התמונה הקודמת */\r\n}\r\n\r\n.fadeOutClass {\r\n    opacity: 0; /* תמונה יוצאת */\r\n    z-index: 1; /* מתחת לתמונה החדשה */\r\n}\r\n\r\n\r\n  \r\n\r\n.monitorPageContainerFull {\r\n    display: flex;\r\n    background-image: linear-gradient(150deg, #061ca7 0%, #67dce2 100%);\r\n    flex-direction: column;\r\n    height: 100vh;\r\n    align-items: center;\r\n    padding-top: 20px;\r\n    justify-content: flex-end;\r\n}\r\n.queuesRoomsMonitorContainerBig{\r\n    display: flex;\r\n}\r\n\r\n.monitorPageContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n.openMonitor {\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    width: 300px;\r\n    height: 120px;\r\n    font-size: 30pt;\r\n    font-weight: 700;\r\n    background-color: #f4f4f4;\r\n    /* צבע כפתור בולט */\r\n    color: rgb(78, 98, 246);\r\n    cursor: pointer;\r\n    border: none;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.openMonitor:hover {\r\n    background-color: #e3eaff;\r\n    /* שינוי צבע בהובר */\r\n}\r\n\r\n.queuesRoomsMonitorContainer {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    /* מאפשר סידור לשורות */\r\n    gap: 10px;\r\n    /* רווחים בין הרכיבים */\r\n    justify-content: center;\r\n    /* ממרכז את הרכיבים אופקית */\r\n    align-items: center;\r\n    /* ממרכז את הרכיבים אנכית */\r\n    height: 100%;\r\n    /* תופס את גובה המסך */\r\n\r\n}\r\n\r\n.roomMonitorContainer {\r\n\r\n    /* width: 350px;\r\n    height: 300px;\r\n    background-color: white; */\r\n\r\n\r\n}\r\n\r\n.dateDisplay {\r\n    color: white;\r\n    font-weight: 700;\r\n    font-size: 18pt;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .roomMonitorContainer {\r\n        width: 250px;\r\n        height: 190px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
